<template>
	<div>
		<v-alert :value="init && !placingProjectAllowed" type="warning">
			Nabór poza terminem przyjmowania wniosków.
		</v-alert>
		<agency-projects-list
			:projects="projects"
			:contest-id="contestData.id"
			:placing-project-allowed="placingProjectAllowed"
			:editing-visible="true"
			:rejecting-visible="true"
			:header="agencyProjectName"
			@project-removed="removeProject"
			empty-warning="W tym naborze nie ma jeszcze wniosków">
		</agency-projects-list>
	</div>
</template>

<script>
	import AgencyProjectsList from "./components/AgencyProjectsList";
	import {Dates} from "@/utils/Dates";
	import {AgencyProject} from "@/api/generated/AgencyProject";
	import {Initializator} from "@/utils/Initializator";
	import {AgencyContest} from "@/api/generated/AgencyContest";

	export default {
		name: "AgencyProjectListView",

		components: {AgencyProjectsList},

		data () {
			return {
				contestData: {
					id: this.$route.params.id,
				},
				projects: null,
				projectsLoaded: false,
				correctionCausesLoaded: false,
				causesMatched: false,
				correctionCauses: [],
				init: false,
				agencyProjectName: "",
			};
		},

		computed: {
			placingProjectAllowed () {
				if (this.init) {
					return this.isInPast(this.contestTerms.contestStartDateTime)
						&& this.isInFuture(this.contestTerms.contestEndDateTime);
				} else {
					return true;
				}
			},
		},

		methods: {
			removeProject (projectId) {
				this.projects.splice(this.projects.findIndex(projects => projects.id === projectId), 1);
			},

			matchCauses () {
				this.correctionCauses.forEach(item => {
					let project = this.projects.find(p => p.id === item.id);
					this.$set(project, "correctionCause", item.correctionCause);
					this.$set(project, "correctionDeadline", item.correctionDeadline);
				});
				this.causesMatched = true;
			},
		},

		created () {
			loadContestProjects(this);
			loadCorrectionCauses(this);
			loadContestTerms(this);
			loadAgencyProjectName(this);
		},

		mixins: [
			Dates,
			Initializator,
		],
	};

	function loadAgencyProjectName(ctx) {
		AgencyContest.getPanelInfo(ctx, ctx.contestData.id,
			successResponse => {
				ctx.agencyProjectName = "Moje wnioski do naboru " + successResponse.name;
			});
	}

	function loadContestProjects (ctx) {
		AgencyProject.getAgencyProjectList(ctx, ctx.contestData.id,
			successResponse => {
				ctx.projects = successResponse;
				ctx.projectsLoaded = true;
				if (ctx.correctionCausesLoaded && !ctx.causesMatched) ctx.matchCauses();
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować wnioski", errorResponse);
			});
	}

	function loadCorrectionCauses (ctx) {
		AgencyProject.getAgencyProjectsCorrectionCauses(ctx, ctx.contestData.id,
			successResponse => {
				ctx.correctionCauses = successResponse;
				ctx.correctionCausesLoaded = true;
				if (ctx.projectsLoaded && !ctx.causesMatched) ctx.matchCauses();
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować powodów do poprawek", errorResponse);
			});
	}

	function loadContestTerms (ctx) {
		AgencyContest.getContestTerms(ctx, ctx.contestData.id,
			successResponse => {
				ctx.contestTerms = successResponse;
				ctx.init = true;
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować warunków konkursu", errorResponse);
			});
	}

</script>

<style scoped>

</style>
